<template>
  <v-container class="mt-4 ml-2 textoPoppins" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="pb-0">
            <div>
              <div class="text-subtitle-1 font-weight-bold">Capa comercial · Vendedor IA</div>
              <div class="text-caption grey--text">Staging · twilio_bd · sin tocar precios/grupos ERP</div>
            </div>
            <v-spacer></v-spacer>
            <v-btn small text @click="irSandbox">
              <v-icon left small>mdi-whatsapp</v-icon>
              Sandbox
            </v-btn>
            <v-btn small color="primary" class="ml-2" :loading="cargando" @click="cargarTodo">
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
            <v-btn small outlined class="ml-2" :loading="invalidando" @click="invalidarCache">
              <v-icon left small>mdi-cached</v-icon>
              Refrescar catálogo IA
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-alert v-if="status" dense outlined type="info" class="mb-3">
              <span class="text-caption">
                Entorno: <strong>{{ status.entorno }}</strong> · BD: <strong>{{ status.db_twilio }}</strong>
                · Catálogo runtime: <strong>{{ status.catalogo && status.catalogo.fuente }}</strong>
                ({{ status.catalogo && status.catalogo.totalCombinaciones }} combos)
              </span>
            </v-alert>

            <v-tabs v-model="tab" background-color="transparent" grow>
              <v-tab>Combinaciones</v-tab>
              <v-tab>Plantillas examen</v-tab>
              <v-tab>Programas</v-tab>
              <v-tab>Modalidades</v-tab>
              <v-tab>Argumentos</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" class="mt-4">
              <!-- COMBINACIONES -->
              <v-tab-item>
                <v-data-table
                  :headers="headersCombo"
                  :items="combinaciones"
                  dense
                  :loading="cargando"
                  class="elevation-0"
                >
                  <template v-slot:item.combinacion_valida_sn="{ item }">
                    <v-chip x-small :color="item.combinacion_valida_sn ? 'green' : 'red'" dark>
                      {{ item.combinacion_valida_sn ? 'válida' : 'inválida' }}
                    </v-chip>
                  </template>
                  <template v-slot:item.estado="{ item }">
                    <v-chip x-small :color="chipEstado(item)" dark>{{ item.estado }}</v-chip>
                  </template>
                  <template v-slot:item.mapeos="{ item }">
                    <span class="text-caption">
                      {{ (item.mapeos || []).filter(m => m.activo_sn).map(m => `${m.anio}→${m.id_curso}`).join(', ') || '—' }}
                    </span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn icon small @click="abrirCombo(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
                    <v-btn icon small color="green" @click="publicarCombo(item)" title="Publicar">
                      <v-icon small>mdi-check-circle</v-icon>
                    </v-btn>
                    <v-btn icon small color="orange" @click="desactivarCombo(item)" title="Desactivar">
                      <v-icon small>mdi-pause-circle</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-tab-item>

              <!-- PLANTILLAS -->
              <v-tab-item>
                <v-data-table
                  :headers="headersPlantilla"
                  :items="plantillas"
                  dense
                  :loading="cargando"
                  class="elevation-0"
                >
                  <template v-slot:item.activo_sn="{ item }">
                    <v-chip x-small :color="item.activo_sn ? 'green' : 'grey'" dark>
                      {{ item.activo_sn ? 'activo' : 'inactivo' }}
                    </v-chip>
                  </template>
                  <template v-slot:item.url_envio_base="{ item }">
                    <a v-if="item.url_envio_base" :href="item.url_envio_base" target="_blank" class="text-caption">
                      {{ item.url_envio_base }}
                    </a>
                    <span v-else class="grey--text">—</span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn icon small @click="abrirPlantilla(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
                  </template>
                </v-data-table>
              </v-tab-item>

              <!-- PROGRAMAS -->
              <v-tab-item>
                <v-data-table :headers="headersProg" :items="programas" dense :loading="cargando">
                  <template v-slot:item.estado="{ item }">
                    <v-chip x-small :color="chipEstado(item)" dark>{{ item.estado }}</v-chip>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn icon small @click="abrirPrograma(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
                    <v-btn icon small color="green" @click="publicarPrograma(item)"><v-icon small>mdi-check-circle</v-icon></v-btn>
                  </template>
                </v-data-table>
              </v-tab-item>

              <!-- MODALIDADES -->
              <v-tab-item>
                <v-data-table :headers="headersMod" :items="modalidades" dense :loading="cargando">
                  <template v-slot:item.estado="{ item }">
                    <v-chip x-small :color="chipEstado(item)" dark>{{ item.estado }}</v-chip>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn icon small @click="abrirModalidad(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
                    <v-btn icon small color="green" @click="publicarModalidad(item)"><v-icon small>mdi-check-circle</v-icon></v-btn>
                  </template>
                </v-data-table>
              </v-tab-item>

              <!-- ARGUMENTOS / OBJECIONES -->
              <v-tab-item>
                <div class="d-flex align-center mb-2">
                  <div class="text-caption grey--text">
                    Checklist del agente: opciones por objeción (tema), curso y modalidad. Prioridad 1 = primero.
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn small color="primary" @click="abrirArgumentoNuevo">
                    <v-icon left small>mdi-plus</v-icon>
                    Alta
                  </v-btn>
                </div>
                <v-data-table
                  :headers="headersArg"
                  :items="argumentos"
                  dense
                  :loading="cargando"
                  class="elevation-0"
                >
                  <template v-slot:item.activo_sn="{ item }">
                    <v-chip x-small :color="item.activo_sn ? 'green' : 'grey'" dark>
                      {{ item.activo_sn ? 'activo' : 'inactivo' }}
                    </v-chip>
                  </template>
                  <template v-slot:item.opcion="{ item }">
                    <span class="text-caption">{{ item.opcion }}</span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn icon small @click="abrirArgumento(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
                    <v-btn
                      icon small color="red"
                      :disabled="!item.activo_sn"
                      title="Desactivar"
                      @click="desactivarArgumento(item)"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog combinación -->
    <v-dialog v-model="dialogCombo" max-width="720" persistent>
      <v-card v-if="comboEdit">
        <v-card-title>Editar combinación · {{ comboEdit.id_configuracion }}</v-card-title>
        <v-card-text>
          <v-textarea v-model="comboEdit.mensaje_alineacion" label="Mensaje alineación" rows="3" outlined dense />
          <v-text-field
            v-model="comboEdit.datos_exigidos_text"
            label="Datos exigidos (JSON array)"
            outlined dense
          />
          <v-switch v-model="comboEdit.combinacion_valida_bool" label="Combinación válida" dense />
          <v-switch v-model="comboEdit.requiere_examen_bool" label="Requiere examen" dense />
          <v-text-field v-model="comboEdit.id_plantilla_examen" label="ID plantilla examen" outlined dense />
          <v-text-field v-model="comboEdit.patron_nombre_curso" label="Patrón curso ERP" outlined dense />
          <v-text-field v-model.number="comboEdit.anio_comercial_default" label="Año comercial default" type="number" outlined dense />

          <v-divider class="my-3"></v-divider>
          <div class="text-subtitle-2 mb-2">Mapeo ERP (año → id_curso)</div>
          <v-row v-for="(m, idx) in comboMapeos" :key="idx" dense>
            <v-col cols="3">
              <v-text-field v-model.number="m.anio" label="Año" type="number" dense outlined hide-details />
            </v-col>
            <v-col cols="3">
              <v-text-field v-model.number="m.id_curso" label="id_curso" type="number" dense outlined hide-details />
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="m.nombre_curso_erp" label="Nombre ERP" dense outlined hide-details />
            </v-col>
            <v-col cols="2" class="d-flex align-center">
              <v-btn icon small color="red" @click="quitarMapeo(idx)"><v-icon small>mdi-delete</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-btn small text color="primary" @click="agregarMapeo"><v-icon left small>mdi-plus</v-icon>Mapeo</v-btn>

          <v-autocomplete
            v-model="cursoErpPick"
            :items="cursosErp"
            :loading="buscandoCursos"
            item-text="curso"
            item-value="id_curso"
            label="Buscar curso ERP (english_admin)"
            dense outlined clearable hide-details class="mt-2"
            @update:search-input="buscarCursosErp"
            @change="aplicarCursoErp"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogCombo = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardando" @click="guardarCombo">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog plantilla -->
    <v-dialog v-model="dialogPlantilla" max-width="560" persistent>
      <v-card v-if="plantillaEdit">
        <v-card-title>Plantilla examen · {{ plantillaEdit.id_plantilla }}</v-card-title>
        <v-card-text>
          <v-text-field v-model="plantillaEdit.nombre_publico" label="Nombre" outlined dense />
          <v-text-field v-model="plantillaEdit.url_envio_base" label="URL envío" outlined dense />
          <v-text-field v-model="plantillaEdit.url_envio_template" label="Plantilla URL ({folio})" outlined dense />
          <v-text-field v-model="plantillaEdit.bd_consulta_resultados" label="BD resultados" outlined dense />
          <v-switch v-model="plantillaEdit.activo_bool" label="Activo" dense />
          <v-textarea v-model="plantillaEdit.notas" label="Notas" rows="2" outlined dense />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogPlantilla = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardando" @click="guardarPlantilla">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog programa / modalidad simple -->
    <v-dialog v-model="dialogProg" max-width="480" persistent>
      <v-card v-if="progEdit">
        <v-card-title>Editar programa</v-card-title>
        <v-card-text>
          <v-text-field v-model="progEdit.nombre_publico" label="Nombre público" outlined dense />
          <v-textarea v-model="progEdit.descripcion_corta" label="Descripción" rows="2" outlined dense />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogProg = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardando" @click="guardarPrograma">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogMod" max-width="480" persistent>
      <v-card v-if="modEdit">
        <v-card-title>Editar modalidad</v-card-title>
        <v-card-text>
          <v-text-field v-model="modEdit.nombre_publico" label="Nombre público" outlined dense />
          <v-textarea v-model="modEdit.descripcion" label="Descripción" rows="2" outlined dense />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogMod = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardando" @click="guardarModalidad">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog argumento / objeción -->
    <v-dialog v-model="dialogArg" max-width="640" persistent>
      <v-card v-if="argEdit">
        <v-card-title>{{ argEdit.id ? 'Editar argumento' : 'Nuevo argumento' }}</v-card-title>
        <v-card-text>
          <v-select
            v-model="argEdit.objecion"
            :items="opcionesObjecion"
            item-text="text"
            item-value="value"
            label="Objeción (tema fase2)"
            outlined dense
          />
          <v-textarea v-model="argEdit.opcion" label="Opción (texto a explicar)" rows="3" outlined dense />
          <v-text-field
            v-model.number="argEdit.prioridad"
            label="Prioridad (1 = primero)"
            type="number"
            min="1"
            outlined dense
          />
          <v-select
            v-model="argEdit.curso"
            :items="opcionesCurso"
            item-text="text"
            item-value="value"
            label="Curso"
            outlined dense
          />
          <v-select
            v-model="argEdit.modalidad"
            :items="opcionesModalidadArg"
            item-text="text"
            item-value="value"
            label="Modalidad"
            outlined dense
          />
          <v-switch v-model="argEdit.activo_bool" label="Activo" dense />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogArg = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardando" @click="guardarArgumento">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snack.show" :color="snack.color" timeout="4000">{{ snack.text }}</v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: 'CapaComercialAdmin',
  data: () => ({
    tab: 0,
    cargando: false,
    guardando: false,
    invalidando: false,
    status: null,
    combinaciones: [],
    plantillas: [],
    programas: [],
    modalidades: [],
    argumentos: [],
    dialogCombo: false,
    comboEdit: null,
    comboMapeos: [],
    dialogPlantilla: false,
    plantillaEdit: null,
    dialogProg: false,
    progEdit: null,
    dialogMod: false,
    modEdit: null,
    dialogArg: false,
    argEdit: null,
    opcionesObjecion: [
      { text: 'Inicio de clases', value: 'inicio_clases' },
      { text: 'Método', value: 'metodo' },
      { text: 'App', value: 'app' },
      { text: 'Salones / clases', value: 'salones' },
      { text: 'Nivel / examen', value: 'nivel' },
      { text: 'Precio / beca', value: 'precio_beca' },
      { text: 'Beca', value: 'beca' },
    ],
    opcionesCurso: [
      { text: 'Intensivo presencial adultos', value: 'curso_intensivo_presencial_adultos' },
      { text: 'Intensivo en línea adultos', value: 'curso_intensivo_en_linea_adultos' },
      { text: 'Teens presencial', value: 'curso_teens_presencial' },
    ],
    opcionesModalidadArg: [
      { text: 'Presencial', value: 'presencial' },
      { text: 'Online', value: 'online' },
    ],
    cursosErp: [],
    buscandoCursos: false,
    cursoErpPick: null,
    snack: { show: false, text: '', color: 'success' },
    headersCombo: [
      { text: 'Config', value: 'id_configuracion' },
      { text: 'Programa', value: 'id_programa' },
      { text: 'Modalidad', value: 'id_modalidad' },
      { text: 'Válida', value: 'combinacion_valida_sn' },
      { text: 'Estado', value: 'estado' },
      { text: 'Mapeo ERP', value: 'mapeos', sortable: false },
      { text: '', value: 'actions', sortable: false },
    ],
    headersPlantilla: [
      { text: 'ID', value: 'id_plantilla' },
      { text: 'Marca', value: 'marca' },
      { text: 'URL', value: 'url_envio_base' },
      { text: 'Activo', value: 'activo_sn' },
      { text: '', value: 'actions', sortable: false },
    ],
    headersProg: [
      { text: 'ID', value: 'id_programa' },
      { text: 'Nombre', value: 'nombre_publico' },
      { text: 'Estado', value: 'estado' },
      { text: 'v', value: 'version' },
      { text: '', value: 'actions', sortable: false },
    ],
    headersMod: [
      { text: 'ID', value: 'id_modalidad' },
      { text: 'Nombre', value: 'nombre_publico' },
      { text: 'Estado', value: 'estado' },
      { text: 'v', value: 'version' },
      { text: '', value: 'actions', sortable: false },
    ],
    headersArg: [
      { text: 'Objeción', value: 'objecion' },
      { text: 'Opción', value: 'opcion' },
      { text: 'Prioridad', value: 'prioridad' },
      { text: 'Curso', value: 'curso' },
      { text: 'Modalidad', value: 'modalidad' },
      { text: 'Activo', value: 'activo_sn' },
      { text: '', value: 'actions', sortable: false },
    ],
  }),
  created() {
    this.cargarTodo()
  },
  methods: {
    apiErrorMsg(e, fallback) {
      return (e && e.response && e.response.data && e.response.data.message)
        || (e && e.message)
        || fallback
    },
    notify(text, color = 'success') {
      this.snack = { show: true, text, color }
    },
    irSandbox() {
      if (this.$route.name === 'twilioSandbox') return
      this.$router.push({ name: 'twilioSandbox' }).catch(() => {})
    },
    chipEstado(item) {
      if (item.estado === 'publicado' && item.activo_sn) return 'green'
      if (item.estado === 'inactivo') return 'grey'
      return 'orange'
    },
    async cargarTodo() {
      this.cargando = true
      try {
        const [st, comb, pl, prog, mod, args] = await Promise.all([
          this.$http.get('vendedor-ia.comercial.status'),
          this.$http.get('vendedor-ia.comercial.combinaciones'),
          this.$http.get('vendedor-ia.comercial.plantillas-examen'),
          this.$http.get('vendedor-ia.comercial.programas'),
          this.$http.get('vendedor-ia.comercial.modalidades'),
          this.$http.get('vendedor-ia.comercial.argumentos'),
        ])
        this.status = st.data
        this.combinaciones = comb.data.combinaciones || []
        this.plantillas = pl.data.plantillas || []
        this.programas = prog.data.programas || []
        this.modalidades = mod.data.modalidades || []
        this.argumentos = args.data.argumentos || []
      } catch (e) {
        this.notify(this.apiErrorMsg(e, 'Error al cargar'), 'error')
      } finally {
        this.cargando = false
      }
    },
    async invalidarCache() {
      this.invalidando = true
      try {
        await this.$http.post('vendedor-ia.comercial.invalidar-cache')
        await this.cargarTodo()
        this.notify('Catálogo IA refrescado')
      } catch (e) {
        this.notify(this.apiErrorMsg(e, 'Error'), 'error')
      } finally {
        this.invalidando = false
      }
    },
    abrirCombo(item) {
      this.comboEdit = {
        ...item,
        combinacion_valida_bool: !!item.combinacion_valida_sn,
        requiere_examen_bool: !!item.requiere_examen_sn,
        datos_exigidos_text: JSON.stringify(item.datos_exigidos || [], null, 0),
      }
      this.comboMapeos = (item.mapeos || []).map((m) => ({ ...m }))
      this.dialogCombo = true
    },
    agregarMapeo() {
      this.comboMapeos.push({
        id_configuracion: this.comboEdit.id_configuracion,
        anio: this.comboEdit.anio_comercial_default || new Date().getFullYear(),
        id_curso: null,
        nombre_curso_erp: '',
        prioridad: 1,
        activo_sn: 1,
      })
    },
    quitarMapeo(idx) {
      const m = this.comboMapeos[idx]
      if (m.id) {
        this.$http.delete(`vendedor-ia.comercial.mapeos/${m.id}`).catch(() => {})
      }
      this.comboMapeos.splice(idx, 1)
    },
    async buscarCursosErp(q) {
      if (!q || q.length < 2) return
      this.buscandoCursos = true
      try {
        const res = await this.$http.get('vendedor-ia.comercial.cursos-erp', { params: { q } })
        this.cursosErp = res.data.cursos || []
      } catch (_) { /* ignore */ } finally {
        this.buscandoCursos = false
      }
    },
    aplicarCursoErp(idCurso) {
      const c = this.cursosErp.find((x) => x.id_curso === idCurso)
      if (!c) return
      this.comboMapeos.push({
        id_configuracion: this.comboEdit.id_configuracion,
        anio: this.comboEdit.anio_comercial_default || new Date().getFullYear(),
        id_curso: c.id_curso,
        nombre_curso_erp: c.curso,
        prioridad: 1,
        activo_sn: 1,
      })
      this.cursoErpPick = null
    },
    async guardarCombo() {
      this.guardando = true
      try {
        let datosExigidos = []
        try {
          datosExigidos = JSON.parse(this.comboEdit.datos_exigidos_text || '[]')
        } catch (_) {
          this.notify('datos_exigidos debe ser JSON array válido', 'error')
          return
        }
        await this.$http.put(`vendedor-ia.comercial.combinaciones/${this.comboEdit.id}`, {
          mensaje_alineacion: this.comboEdit.mensaje_alineacion,
          datos_exigidos: datosExigidos,
          combinacion_valida_sn: this.comboEdit.combinacion_valida_bool,
          requiere_examen_sn: this.comboEdit.requiere_examen_bool,
          id_plantilla_examen: this.comboEdit.id_plantilla_examen,
          patron_nombre_curso: this.comboEdit.patron_nombre_curso,
          anio_comercial_default: this.comboEdit.anio_comercial_default,
        })
        for (const m of this.comboMapeos) {
          if (m.id_curso && m.anio) {
            await this.$http.post('vendedor-ia.comercial.mapeos', {
              id: m.id || undefined,
              id_configuracion: this.comboEdit.id_configuracion,
              anio: m.anio,
              id_curso: m.id_curso,
              nombre_curso_erp: m.nombre_curso_erp,
              prioridad: m.prioridad || 1,
              activo_sn: 1,
            })
          }
        }
        this.dialogCombo = false
        await this.cargarTodo()
        this.notify('Combinación guardada')
      } catch (e) {
        this.notify(this.apiErrorMsg(e, 'Error al guardar'), 'error')
      } finally {
        this.guardando = false
      }
    },
    async publicarCombo(item) {
      try {
        await this.$http.post(`vendedor-ia.comercial.combinaciones/${item.id}/publicar`)
        await this.cargarTodo()
        this.notify('Combinación publicada')
      } catch (e) {
        this.notify(this.apiErrorMsg(e, 'Error'), 'error')
      }
    },
    async desactivarCombo(item) {
      try {
        await this.$http.post(`vendedor-ia.comercial.combinaciones/${item.id}/desactivar`)
        await this.cargarTodo()
        this.notify('Combinación desactivada')
      } catch (e) {
        this.notify(this.apiErrorMsg(e, 'Error'), 'error')
      }
    },
    abrirPlantilla(item) {
      this.plantillaEdit = { ...item, activo_bool: !!item.activo_sn }
      this.dialogPlantilla = true
    },
    async guardarPlantilla() {
      this.guardando = true
      try {
        await this.$http.put(`vendedor-ia.comercial.plantillas-examen/${this.plantillaEdit.id}`, {
          nombre_publico: this.plantillaEdit.nombre_publico,
          url_envio_base: this.plantillaEdit.url_envio_base,
          url_envio_template: this.plantillaEdit.url_envio_template,
          bd_consulta_resultados: this.plantillaEdit.bd_consulta_resultados,
          activo_sn: this.plantillaEdit.activo_bool,
          notas: this.plantillaEdit.notas,
        })
        this.dialogPlantilla = false
        await this.cargarTodo()
        this.notify('Plantilla guardada')
      } catch (e) {
        this.notify(this.apiErrorMsg(e, 'Error'), 'error')
      } finally {
        this.guardando = false
      }
    },
    abrirPrograma(item) {
      this.progEdit = { ...item }
      this.dialogProg = true
    },
    async guardarPrograma() {
      this.guardando = true
      try {
        await this.$http.put(`vendedor-ia.comercial.programas/${this.progEdit.id}`, {
          nombre_publico: this.progEdit.nombre_publico,
          descripcion_corta: this.progEdit.descripcion_corta,
        })
        this.dialogProg = false
        await this.cargarTodo()
        this.notify('Programa guardado')
      } catch (e) {
        this.notify(this.apiErrorMsg(e, 'Error'), 'error')
      } finally {
        this.guardando = false
      }
    },
    async publicarPrograma(item) {
      try {
        await this.$http.post(`vendedor-ia.comercial.programas/${item.id}/publicar`)
        await this.cargarTodo()
        this.notify('Programa publicado')
      } catch (e) {
        this.notify(this.apiErrorMsg(e, 'Error'), 'error')
      }
    },
    abrirModalidad(item) {
      this.modEdit = { ...item }
      this.dialogMod = true
    },
    async guardarModalidad() {
      this.guardando = true
      try {
        await this.$http.put(`vendedor-ia.comercial.modalidades/${this.modEdit.id}`, {
          nombre_publico: this.modEdit.nombre_publico,
          descripcion: this.modEdit.descripcion,
        })
        this.dialogMod = false
        await this.cargarTodo()
        this.notify('Modalidad guardada')
      } catch (e) {
        this.notify(this.apiErrorMsg(e, 'Error'), 'error')
      } finally {
        this.guardando = false
      }
    },
    async publicarModalidad(item) {
      try {
        await this.$http.post(`vendedor-ia.comercial.modalidades/${item.id}/publicar`)
        await this.cargarTodo()
        this.notify('Modalidad publicada')
      } catch (e) {
        this.notify(this.apiErrorMsg(e, 'Error'), 'error')
      }
    },
    abrirArgumentoNuevo() {
      this.argEdit = {
        id: null,
        objecion: 'metodo',
        opcion: '',
        prioridad: 1,
        curso: 'curso_intensivo_presencial_adultos',
        modalidad: 'presencial',
        activo_bool: true,
      }
      this.dialogArg = true
    },
    abrirArgumento(item) {
      this.argEdit = {
        ...item,
        activo_bool: !!item.activo_sn,
      }
      this.dialogArg = true
    },
    async guardarArgumento() {
      this.guardando = true
      try {
        const body = {
          objecion: this.argEdit.objecion,
          opcion: this.argEdit.opcion,
          prioridad: this.argEdit.prioridad || 1,
          curso: this.argEdit.curso,
          modalidad: this.argEdit.modalidad,
          activo_sn: this.argEdit.activo_bool ? 1 : 0,
          marca: 'inbi',
        }
        if (this.argEdit.id) {
          await this.$http.put(`vendedor-ia.comercial.argumentos/${this.argEdit.id}`, body)
        } else {
          await this.$http.post('vendedor-ia.comercial.argumentos', body)
        }
        this.dialogArg = false
        await this.cargarTodo()
        this.notify('Argumento guardado')
      } catch (e) {
        this.notify(this.apiErrorMsg(e, 'Error al guardar'), 'error')
      } finally {
        this.guardando = false
      }
    },
    async desactivarArgumento(item) {
      try {
        await this.$http.delete(`vendedor-ia.comercial.argumentos/${item.id}`)
        await this.cargarTodo()
        this.notify('Argumento desactivado')
      } catch (e) {
        this.notify(this.apiErrorMsg(e, 'Error'), 'error')
      }
    },
  },
}
</script>
